// axios基础的封装
import axios from "axios";
import { ElMessage } from 'element-plus'
import 'element-plus/theme-chalk/el-message.css'
import { useUserStore } from "@/stores/userStore";
import router from "@/router";

const service = axios.create({
    
    baseURL: import.meta.env.VITE_APP_BASE_API,
    
    timeout: 50000,
    headers: { "Content-Type": "application/json;charset=utf-8" },
})

// 拦截器

// axios请求拦截器
service.interceptors.request.use(config => {
  let language=localStorage.getItem('language');
  if(language=='zh-cn'){
      language='zn'
  }
  // console.log('config',config.url)
  config.headers['locale'] = 'CustomValue';

  const userStore = useUserStore()
    // 2. 按照后端的要求拼接token数据
    const token = userStore.userInfo.token
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
        
    }
    if(config.method=='get'){
      config.url=config.url+'?locale='+language.toLowerCase()
    }else{
      //post请求或其他的合并数组
      config.data = Object.assign({ 'locale': language.toLowerCase() }, config.data)
    }
    // if(config.url!='/api/v1/message_list' && config.url!='/api/v1/exchangeRate'){
    //   userStore.getRate()
    // }
    
    return config;

}, error => {return Promise.reject(error);})

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const userStore = useUserStore()
    // 检查配置的响应类型是否为二进制类型（'blob' 或 'arraybuffer'）, 如果是，直接返回响应对象
    if (
      response.config.responseType === "blob" ||
      response.config.responseType === "arraybuffer"
    ) {
      return response;
    }

    const { code, message } = response.data;
    //100404商品不存在 100405商品已下架
    if (code === 0) {
      //成功
      return response.data;
    } else if (code === 401) {
      userStore.clearUserInfo()
      router.push('/login')
    } else if(code==404){
      router.push('/404')
    } else if(code==100404||code==100405){
      // if(response.data.data){//去店铺
      //   router.push(`/userDetails/${response.data.data.user_id}?type=1`)
      // }else{
        router.push('/404')
      // }
    }else{
      ElMessage.error(message || "系统出错");
    }

    return Promise.reject(new Error(message || "Error"));
  },
  (error) => {
    // 异常处理
    if (error.response.data) {
      const { code, message } = error.response.data;
      if (code === 401) {
        ElNotification({
          title: "提示",
          message: "您的会话已过期，请重新登录",
          type: "info",
        });
       
        localStorage.clear(); // @vueuse/core 自动导入
        window.location.href = '/';
        
      } else {
        ElMessage.error(message || "系统出错");
      }
    }
    return Promise.reject(error.message);
  }
);

export default service